import { createSelector } from '@reduxjs/toolkit';

import { NAME } from './constants';

import type { TRootState } from 'store';

const getOnboardingSlice = (state: TRootState) => state[NAME];

// Journey/tooltip selectors
const getJourneyState = createSelector(getOnboardingSlice, slice => slice.journey);

export const getCurrentJourney = createSelector(getJourneyState, journey => journey.currentJourney);

export const getCurrentStep = createSelector(getJourneyState, journey => journey.currentStep);

export const getCallbackTriggerId = createSelector(
  getJourneyState,
  journey => journey.callbackTriggerId
);

// Registration selectors
const getRegistrationState = createSelector(getOnboardingSlice, slice => slice.registration);

export const getRegistrationStep = createSelector(
  getRegistrationState,
  registration => registration.currentStep
);

export const getUserData = createSelector(
  getRegistrationState,
  registration => registration.userData
);

export const getRegistrationProgress = createSelector(
  getRegistrationState,
  registration => registration.progress
);

export const getRegistrationLoading = createSelector(
  getRegistrationState,
  registration => registration.isLoading
);

export const getRegistrationError = createSelector(
  getRegistrationState,
  registration => registration.error
);

export default {
  getCurrentJourney,
  getCurrentStep,
  // Registration selectors
  getRegistrationStep,
  getUserData,
  getRegistrationProgress,
  getRegistrationLoading,
  getRegistrationError,
};
